<template>
  <div class="inner-box">
    <div class="boardList" v-if="viewType == 'list'">

      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">{{title}} 리스트</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-document-add" @click="goWrite" v-if="auth.grantInsert === 'Y' ">글쓰기</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow" v-if="auth.grantDelete === 'Y' ">삭제</el-button>
            <el-button type="primary" icon="el-icon-search" @click="boardRefreshOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-col :span="12">
                <el-form-item label-width="4em" label="작성일">
                  <el-date-picker type="date" placeholder="작성일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="padding: 0;">-</el-col>
              <el-col :span="10">
                <el-form-item label-width="0px">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="80px" label="검색타입">
                <el-select v-model="form.searchType">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['DocSearchType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="0px">
                <el-input type="text" v-model="form.searchCont" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>



      <ag-grid-vue
          ref="gridSub"
          style="width: 100%; height: 70vh; min-height: 400px; margin-top: 10px;"
          class="ag-theme-alpine"
          :enableRangeSelection="true"
          :column-defs="columnDefs"
          :grid-options="gridOptions"
          :default-col-def="defaultColDef"
          :row-data="data"
          :framework-components="frameworkComponents"
          :pagination="true"
          :paginationAutoPageSize="true"
          @rowDoubleClicked="rowDoubleClick"
          @cell-clicked="onCellClicked"
          @grid-ready="onReady"
          @pagination-changed="onPaginationChanged"
          @first-data-rendered="onFirstDataRendered"


      />
    </div>
    <!--  게시판 쓰기  -->
    <doc-write ref='write' :custParam = "custParam" :title='title' v-on:viewType="changeView('write')" v-on:refresh="goOpen" v-else-if="viewType == 'write'"/>
    <!--  게시판 읽기  -->
    <doc-read ref='content' :custParam = "custParam" :title='title' v-on:viewType="changeView('read')" v-on:refresh="goOpen" v-else/>


  </div>
</template>

<script>
import DocRead from "@/views/Bbs/DocRead.vue";
import DocWrite from "@/views/Bbs/DocWrite.vue";
import _ from "lodash";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import AgGridScanAttach from "@/components/agGrid/AgGridScanAttach";
import PopDocVisitorList from "@/components/Bbs/PopDocVisitorList";

export default {
  name:'BoardList',
  components:{DocRead,DocWrite},
  props:{
    title:{
      type:String,
      required: true
    },
    type:{
      type:String,
      required: true
    },
  },
  data(){
    return {
      form: {
        startDt: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        searchCont:'',
        searchType:"TitleContent",
      },
      parameter:[],
      srcId1:'',
      srcId2:'',
      srcId3:'',
      paramType:'',
      boardMng:{},
      boardSubCd:'',
      boardList:[],
      subList:[],
      viewType: '',
      custParam:[],
      gridOptions: {
        // onColumnResized: true,
        // enableFilter: true,
        // enableSorting: true,
        // suppressRowTransform: true
      },
      frameworkComponents: {
        AgGridScanAttach: AgGridScanAttach,
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        //editable: true
      },
      gridApi : null ,    //gridAip
      columnApi : null ,  //columApi
      columnDefs: [] ,    //comulum Defs
      data: [],
      combos: {
        'DocSearchType' : [],           //검색타입
      },
    }
  },
  beforeMount() {
    this.getParameter();
    this.createColumnDefs(); //그리드 컬럼정의 함수 호출;
    // this.viewType = 'list';
    this.type == 'read' ? this.viewType = this.type : this.viewType = 'list';
    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };
    this.init();
  },
  mounted(){
    this.getBoardList();
  },
  methods: {
    getParameter(){
      this.parameter = this.$menu.getGrants().parameter.split("&");
      this.srcId1 = this.parameter[0]?.substring(this.parameter[0]?.indexOf('=')+1); // 콜센터,센터 구분
      this.srcId2 = this.parameter[1]?.substring(this.parameter[1]?.indexOf('=')+1); // 공지,일반 구분
      this.srcId3 = this.parameter[2]?.substring(this.parameter[2]?.indexOf('=')+1); // 게시판 종류 구분
    },
    getBoardList(){
      const {asAgentId, compCd} = this.$store.state.loginInfo;
      if(asAgentId && compCd) {
        this.$store.commit('loading')
        this.startDt = this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.endDt = this.$moment().format('YYYY-MM-DD');
        this.$http.post(`/api/boardMng/list`,{
          companyId: compCd,
          srcId1: this.srcId1,
          srcId2: this.srcId2,
          srcId3: "",
          srcId4: "",
          searchType: this.form.searchType,
          searchTxt: this.form.searchCont,
          startDt: this.isEmpty(this.form.startDt),
          endDt: this.isEmpty(this.form.endDt),
          asAgentId: asAgentId,
          importance: this.selectType(),
          sortType : true,
          page : 1,
          totalPage : 9999,
          totalCount : 9999,
          curPage : 0,
          processTime : ""
        })
        .then(response => {
          this.data = response.data;
        }).finally(() => {
          this.$store.commit('finish')
        });
      } else {
        this.data = [];
      }
    },
    boardRefreshOpen() {
      this.$store.commit('setBoardRefresh', true);
      this.goOpen();
    },
    goOpen(){

      this.viewType = 'list';
      this.$store.commit('loading')

      if (this.form.startDt > this.form.endDt) {
        this.$swal({ type: "error", text: "작성일의 시작 날짜가 마지막 날짜보다 더 빠를 수 없습니다." });
        this.$store.commit('finish')
        return;
      }

      this.$http.post(`/api/boardMng/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: this.srcId1,
        srcId2: this.srcId2,
        srcId3: "",
        srcId4: "",
        searchType: this.form.searchType,
        searchTxt: this.form.searchCont,
        startDt:this.isEmpty(this.form.startDt),
        endDt: this.isEmpty(this.form.endDt),
        asAgentId: this.$store.state.loginInfo.asAgentId,
        importance: this.selectType(),
        sortType : true,
        page : 1,
        totalPage : 9999,
        totalCount : 9999,
        curPage : 0,
        processTime : ""
      })
      .then(response => {
        this.data = response.data;
      }).finally(() => {
        if(this.$store.state.board.refresh) {
          this.gridApi.paginationGoToFirstPage();
        }
        this.$store.commit('finish')
      });

    },
    deleteRow(){

      const grid = this.$refs.gridSub
      
      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "Y"
      })

      if(chkDatas.length > 0) {
        let submitList = [];
        chkDatas.forEach(x=>{
          submitList.push({
            docId : x.docId
          })
        })

        this.$swal({
          type: 'info',
          text: `선택한 프로그램을 삭제하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
              if (result.value) {
                this.$store.commit('loading')
                this.$http
                    .put('/api/boardMng/delete', submitList)
                    .then(response => {
                      this.$swal({ type: 'success', text: '삭제되었습니다.' });
                      this.goOpen();
                    })
                    .catch(({ message }) => {
                      if (message === "Request failed with status code 500") {
                        this.$swal({ type: "error", text: "오류가 발생했습니다." });
                      }
                    }).finally(() => {
                      this.$store.commit('finish')
                });
              }
        })
      } else {
        this.$message({
          message: '삭제할 데이터가 없습니다.',
          type: 'error'
        })
      }
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    goWrite(){
      this.viewType = 'write';
    },
    onRead(row){
      //저장 시작
      this.$http
          .put('/api/boardMng/read',{
            companyId: this.$store.state.loginInfo.compCd,
            srcId1: "DOC",
            srcId2: row.docId,
            srcId3: "",
            srcId4: "",
            creatorId: this.$store.state.loginInfo.id,
            processTime: "",
            visitorId: 0
          })
          .then(response => {
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    //그리드 Ready
    onReady(params) {
      this.gridApi = this.gridOptions.api;
      this.columnApi = this.gridOptions.columnApi;

      this.createColumnDefs();
      // this.queryPage(0);
      //this.query()

      const updateData = (data) => {
        data.forEach(function (d, index) {
          d.id = 'R' + (index + 1);
        });
        const dataSource = {
          rowCount: undefined,
          getRows: (params) => {

            setTimeout(function () {
              const dataAfterSortingAndFiltering = this.sortAndFilter(
                  data,
                  params.sortModel,
                  params.filterModel
              );
              const rowsThisPage = dataAfterSortingAndFiltering.slice(
                  params.startRow,
                  params.endRow
              );

              let lastRow = -1;
              if (dataAfterSortingAndFiltering.length <= params.endRow) {
                lastRow = dataAfterSortingAndFiltering.length;
              }

              params.successCallback(rowsThisPage, lastRow);
            }, 500);
          },

        };
        params.api.setDatasource(dataSource);
      };

      updateData(this.boardList);

    },
    onPaginationChanged: (params) => {
      if (params.newPage) {
        const currentPage = params.api.paginationGetCurrentPage();
        localStorage.setItem('DocListcurrentPage', JSON.stringify(currentPage));
      }
    },
    onFirstDataRendered: (params) => {
      const pageToNavigate = JSON.parse(localStorage.getItem('DocListcurrentPage'));
      params.api.paginationGoToPage(pageToNavigate);
    },
    sortAndFilter(allOfTheData, sortModel, filterModel){
      return this.sortData(sortModel, this.filterData(filterModel, allOfTheData));
    },
    sortData(sortModel, data) {
      const sortPresent = sortModel && sortModel.length > 0;
      if (!sortPresent) {
        return data;
      }

      const resultOfSort = data.slice();
      resultOfSort.sort(function (a, b) {
        for (let k = 0; k < sortModel.length; k++) {
          const sortColModel = sortModel[k];
          const valueA = a[sortColModel.colId];
          const valueB = b[sortColModel.colId];

          if (valueA == valueB) {
            continue;
          }
          const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
          if (valueA > valueB) {
            return sortDirection;
          } else {
            return sortDirection * -1;
          }
        }

        return 0;
      });

      return resultOfSort;
    },
    filterData(filterModel, data) {
      const filterPresent = filterModel && Object.keys(filterModel).length > 0;
      if (!filterPresent) {
        return data;
      }
      const resultOfFilter = [];
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (filterModel.age) {
          const age = item.age;
          const allowedAge = parseInt(filterModel.age.filter);
          // EQUALS = 1;
          // LESS_THAN = 2;
          // GREATER_THAN = 3;
          if (filterModel.age.type == 'equals') {
            if (age !== allowedAge) {
              continue;
            }
          } else if (filterModel.age.type == 'lessThan') {
            if (age >= allowedAge) {
              continue;
            }
          } else {
            if (age <= allowedAge) {
              continue;
            }
          }
        }
        if (filterModel.year) {
          if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
            // year didn't match, so skip this record
            continue;
          }
        }
        if (filterModel.country) {
          if (filterModel.country.values.indexOf(item.country) < 0) {
            continue;
          }
        }
        resultOfFilter.push(item);
      }
      return resultOfFilter;
    },
    selectType(){
      // let val = '';
      // if(this.srcId2 == 'Freeboard' && this.srcId3 == 'Normal'){
      //   val = '';
      //   this.paramType = 'Freeboard';
      // }else if(this.srcId2 == 'Notice' && this.srcId3 == 'Normal'){
      //   val = this.srcId3;
      //   this.paramType = 'Notice';
      // }else if(this.srcId2 == 'Notice' && this.srcId3 == 'Tech'){
      //   val = 'Importance';
      //   this.paramType = 'Tech';
      // }else{
      //   val = this.srcId3;
      //   this.paramType = this.srcId3;
      // }
      return this.srcId3;
    },
    changeView(type){
      if(type == 'write'){
        this.viewType = this.$refs.write.viewType;
      }else{
        this.viewType = this.$refs.content.viewType;
      }

      if(this.viewType == 'modify'){
        this.viewType = 'write';
      }else{
        this.custParam = [];
      }
    },
    //컬럼정의 함수
    createColumnDefs() {
      const vm = this;

      if(this.srcId2 == 'Notice' && this.srcId3 == 'Importance'){
        this.columnDefs = [
          {
            headerName: '선택'
            , field:'regYn'
            , width : 80
            , editable: false
            , cellRenderer: 'checkboxRenderer'
            , cellRendererParams: {
              trueValue: 'Y',
              falseValue: 'N',
              disable: this.grantDelete !== 'Y'
            },
          },
          {
            headerName: '제목'
            , width : 550
            , field: 'docNm'
            , cellStyle:{textAlign: 'left'}
          },
          {
            headerName: '모델명',
            width : 150 ,
            field: 'modelNm',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '작성자',
            width : 150 ,
            field: 'creatorNm',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '작성일'
            , width : 200
            , field: 'createDt'
            , cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
            }
          },
          {
            headerName: '조회수',
            width : 150 ,
            field: 'readCnt',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '확인자수',
            width : 150 ,
            field: 'confirmCnt',
            cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
            }
          },
          {headerName:'', field:'docId', hide : true}
        ]
      }else if(this.srcId2 == 'Notice' && this.srcId3 == 'Normal'){
        this.columnDefs = [
          {
            headerName: '제목'
            , width : 550
            , field: 'docNm'
            , cellStyle:{textAlign: 'left'}
          },
          {
            headerName: '모델명',
            width : 150 ,
            field: 'modelNm',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '작성자',
            width : 150 ,
            field: 'creatorNm',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '작성일'
            , width : 200
            , field: 'createDt'
            , cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
            }
          },
          {
            headerName: '조회수',
            width : 150 ,
            field: 'readCnt',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '확인자수',
            width : 150 ,
            field: 'confirmCnt',
            cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
            }
          },
          {headerName:'', field:'docId', hide : true}
        ]
      }
      else{
        this.columnDefs = [
          {
            headerName: '선택'
            , field:'regYn'
            , width : 80
            , editable: false
            , cellRenderer: 'checkboxRenderer'
            , cellRendererParams: (params) => {
              return {
                trueValue: 'Y',
                falseValue: 'N',
                disable: this.sampleChk(params.data.docId)
              }
            },
          },
          {
            headerName: '제목'
            , width : 550
            , field: 'docNm'
            , cellStyle:{textAlign: 'left'}
          },
          {
            headerName: '작성자',
            width : 150 ,
            field: 'creatorNm',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '작성일'
            , width : 200
            , field: 'createDt'
            , cellStyle:{textAlign: 'center'},
            valueFormatter: (params) => {
              return vm.getDateFormat(`${params.value}`)
            }
          },
          {
            headerName: '조회수',
            width : 150 ,
            field: 'readCnt',
            cellStyle:{textAlign: 'center'}
          },
          {
            headerName: '확인자수',
            width : 150 ,
            field: 'confirmCnt',
            cellStyle:{textAlign: 'center'},
            cellRenderer: (params) => {
              return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
            }
          },
          {headerName:'', field:'docId', hide : true}
        ]
      }
    },
    rowDoubleClick(params){
      const voRow = params.data //선택된 Row

      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/detail`,{
        companyId: this.$store.state.loginInfo.compCd,
        docId: voRow.docId,
        processTime : ""
      })
      .then(response => {
        this.custParam = Object.assign(response.data[0], response.data[1]);
        this.viewType = 'read';
        this.onRead(voRow);
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'confirmCnt') {
        this.openModal(params.data.docId);
      }
    },
    openModal(docId){

      const vm = this;

      this.$modal.open({
        width: 400,
        component: PopDocVisitorList,
        parent: this,
        props: {
          title: "확인자리스트",
          docId : docId
        },
        events: {
          close(params) {
          },
        }
      });
    },
    typeSwitch(type){
      switch (type){
        case 'Normal':
          return type ='일반공지';
        case 'Importance':
          return type ='기술공지';
        case 'Quality':
          return type ='품질정보서';
        case 'ProductChange':
          return type ='제품교환';
        case 'Default':
          return type ='';
      }
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/boardMng/init`)
          .then(response => {
            this.combos['DocSearchType'] = response.data.docSearchType;        //검색타입
          }).finally(() => {
            this.$store.commit('finish');
          });
    },
    
    sampleChk(docId){
      if(docId == 23332 || docId == 23333){
        return true
      }else{
        return false;
      }
    }
  },
  watch: {

  },
  computed: {
    auth() {
      const {grantDelete, grantInsert, grantSelect, grantUpdate, grantExtend1, grantExtend2} = this.$menu.getGrants();
        return {grantDelete, grantInsert, grantSelect, grantUpdate, grantExtend1, grantExtend2}
    }
  },
}
</script>
<style scoped>
.ag-paging-button {
  position: unset;
}

.search-form .form-group {
  width: 30%;
}

</style>